export default "__VITE_ASSET__eb5165b6__"